var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('loading',{attrs:{"active":_vm.loading,"can-cancel":true,"color":_vm.colorLoader,"is-full-page":true},on:{"update:active":function($event){_vm.loading=$event}}}),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }